<template>
  <div>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <SlideShowSection :items="slideShowItems" />

      <v-container class="home-view_events">
        <EventCard
          v-for="(event, i) in events"
          :key="i"
          v-fade
          v-bind="event"
          :type="i >= 4 && xsOnly ? 'horizontal' : 'vertical'"
          hide-date
        />

        <ButtonWidget v-fade to="/coberturas" align="center">
          Ver mais
        </ButtonWidget>

        <BannerWidget
          category="Retângulo"
          type="carousel"
          :items-to-show="{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }"
        />
      </v-container>

      <InstagramFeedWidget
        v-if="informations.elfsight"
        v-fade
        :elfsightKey="informations.elfsight"
        class="mt-10"
      />
    </template>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import InstagramFeedWidget from "../components/widgets/InstagramFeedWidget.vue";
import BannerWidget from "../components/widgets/BannerWidget.vue";
import EventCard from "../components/cards/EventCard.vue";
import ButtonWidget from "../components/widgets/ButtonWidget.vue";

export default {
  data: () => ({
    loading: true,
    mixedEvents: [],
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    slideShowItems() {
      return this.mixedEvents
        .filter((event) => event.featured === 1)
        .slice(0, 5);
    },
    events() {
      const slideShowItemsIds = this.slideShowItems.map((item) => item.id);

      return this.mixedEvents
        .filter((event) => !slideShowItemsIds.includes(event.id))
        .slice(0, 10);
    },
  },
  created() {
    this.$rest("events")
      .get({
        params: {
          itemsPerPage: 15,
        },
      })
      .then((data) => (this.mixedEvents = data))
      .finally(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    SlideShowSection,
    InstagramFeedWidget,
    BannerWidget,
    EventCard,
    ButtonWidget,
  },
};
</script>

<style lang="scss">
.home-view_events {
  display: grid;
  gap: 30px;
  grid-template:
    "event-1 event-1 event-1 event-2 event-2 event-2"
    "event-3 event-3 event-3 event-4 event-4 event-4"
    "banner banner banner banner banner banner"
    "event-5 event-5 event-6 event-6 event-7 event-7"
    "event-8 event-8 event-9 event-9 event-10 event-10"
    "button button button button button button";

  @for $i from 1 through 10 {
    .event-card-container:nth-child(#{$i}) {
      grid-area: event-#{$i};
    }
  }

  .button-widget-wrap {
    grid-area: button;
  }

  .banner-widget {
    grid-area: banner;
  }
}

@media screen and (max-width: 600px) {
  .home-view_events {
    grid-template:
      "event-1"
      "event-2"
      "event-3"
      "event-4"
      "banner"
      "event-5"
      "event-6"
      "event-7"
      "event-8"
      "event-9"
      "event-10"
      "button";
  }
}
</style>
